import React, { createContext, useState, useContext } from 'react';
import { webShopService } from 'services/Services';
import { CheckCompanyForSaleResponse } from 'models/WebShop';
import useAccountData from 'hooks/useAccountData';
import { AccessLevel } from 'models/Company';

interface CompanySaleCheckContextType {
  companySaleCheck: { [companyId: string]: CheckCompanyForSaleResponse };
  fetchCompanySaleCheck: (companyId: string, organizationNumber: string) => Promise<void>;
}

const CompanySaleCheckContext = createContext<CompanySaleCheckContextType | undefined>(undefined);

export const CompanySaleCheckProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [companySaleCheck, setCompanySaleCheck] = useState<{ [companyId: string]: CheckCompanyForSaleResponse }>({});
  const { getCurrentCompany } = useAccountData();

  const fetchCompanySaleCheck = async (companyId: string, organizationNumber: string) => {

    const company = await getCurrentCompany(companyId);

    if (company === null ){
      setCompanySaleCheck(prev => ({
        ...prev,
        [companyId]: { allowed: false, ReasonWhyNotAllowed: ""},
      }));

    }
    else{
      const response = await webShopService.checkCompanyForSale(companyId, organizationNumber);
    if (response) {
      setCompanySaleCheck(prev => ({
        ...prev,
        [companyId]: response,
      }));
    }
    }
    
  };

  return (
    <CompanySaleCheckContext.Provider value={{ companySaleCheck, fetchCompanySaleCheck }}>
      {children}
    </CompanySaleCheckContext.Provider>
  );
};

export const useCompanySaleCheck = () => {
  const context = useContext(CompanySaleCheckContext);
  if (!context) {
    throw new Error('useCompanySaleCheck must be used within a CompanySaleCheckProvider');
  }
  return context;
};
